
const state = {
    auth: null,
    oauth: null,
}

export default state;